'use client';

import classNames from 'classnames';
import Link from 'next/link';
import { FC, useMemo } from 'react';

import { useUserStore } from '@/features/user';
import { SITE_PAGES } from '@/shared/config';
import { Icon } from '@/shared/ui';

import styles from './favoriteHeaderLink.module.scss';
import { useAuthFavoriteStore } from '../../model/authFavoriteStore';
import { useFavoriteGuestStore } from '../../model/favoriteGuestStore';

interface FavoriteHeaderLinkProps {
  className?: string;
}

export const FavoriteHeaderLink: FC<FavoriteHeaderLinkProps> = (props) => {
  const { className } = props;
  const isAuth = useUserStore((s) => s.isAuth);
  const guestCount = useFavoriteGuestStore((s) => s.entries.length);
  const authCount = useAuthFavoriteStore((s) => s.entries.length);

  const hasItems = useMemo(() => {
    return isAuth ? authCount > 0 : guestCount > 0;
  }, [isAuth, authCount, guestCount]);

  return (
    <Link
      className={classNames(styles.link, className)}
      href={SITE_PAGES.favorites}
      title="Избранное"
    >
      <Icon name={hasItems ? 'likeFavorites' : 'likeEmpty'} />
    </Link>
  );
};
